<template>
  <div class="w-64 bg-primary-dark h-screen flex flex-col">
    <!-- Titlu Sidebar -->
    <div class="p-4 text-2xl font-bold text-accent-light">
      OG LAND <span class="text-blue-400">POLICE</span>
    </div>

    <!-- Meniu -->
    <nav class="flex-1">
      <ul>
        <!-- Dashboard -->
        <li class="hover:bg-hover-dark">
          <router-link
            to="/dashboard"
            class="block p-4 text-text-light hover:text-white transition"
          >
            Dashboard
          </router-link>
        </li>

        <!-- Membri -->
        <li class="hover:bg-hover-dark">
          <router-link
            to="/membri"
            class="block p-4 text-text-light hover:text-white transition"
          >
            Membri
          </router-link>
        </li>

        <!-- Raport Săptămânal -->
        <li class="hover:bg-hover-dark">
          <router-link
            to="/raport-saptamanal"
            class="block p-4 text-text-light hover:text-white transition"
          >
            Raport Săptămânal
          </router-link>
        </li>

        <!-- Conturi (doar pentru Owner) -->
        <li v-if="userRole === 'Owner'" class="hover:bg-hover-dark">
          <router-link
            to="/conturi"
            class="block p-4 text-text-light hover:text-white transition"
          >
            Conturi
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "SidebarComponent",
  data() {
    return {
      userRole: localStorage.getItem("role"), // Preluăm rolul utilizatorului din localStorage
    };
  },
};
</script>

<style scoped>
/* Fundal principal sidebar */
.bg-primary-dark {
  background-color: #1A1528; /* Culoarea casetei Dashboard */
}

/* Hover pentru elemente */
.hover\:bg-hover-dark:hover {
  background-color: #262642; /* Ușor mai deschis la hover */
}

/* Text */
.text-text-light {
  color: #b3b3cc; /* Gri deschis */
}

.text-accent-light {
  color: #a855f7; /* Mov deschis */
}
</style>
